import { render, staticRenderFns } from "./LimitExcededExcel.vue?vue&type=template&id=17def404&scoped=true&lang=pug"
import script from "./LimitExcededExcel.vue?vue&type=script&lang=js"
export * from "./LimitExcededExcel.vue?vue&type=script&lang=js"
import style0 from "./LimitExcededExcel.vue?vue&type=style&index=0&id=17def404&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17def404",
  null
  
)

export default component.exports